import type React from 'react';
import styles from './LoadingSpinner.module.css';

export interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  message?: string;
  fullScreen?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'medium',
  message,
  fullScreen = false,
}) => {
  const spinnerContent = (
    <>
      <div className={`${styles.spinner} ${styles[size]}`} role="status" aria-live="polite">
        <span className={styles.visuallyHidden}>Loading...</span>
      </div>
      {message && <p className={styles.message}>{message}</p>}
    </>
  );

  if (fullScreen) {
    return <div className={styles.fullScreenContainer}>{spinnerContent}</div>;
  }

  return <div className={styles.container}>{spinnerContent}</div>;
};
